import {
  combineReducers
} from 'redux';
import {
  UPDATE_SHIRT_PRICE,
  UPDATE_SHIRT_PRICE_BY_ATTR,
  UPDATE_SHIRT_PRICE_BY_CONTRAST,
  UPDATE_SHIRT_PRICE_BY_FABRIC,
  UPDATE_SHIRT_PRICE_BY_BUTTONS
} from '../../constants/actionTypes';

const shirtPrice = (state = {
  price: 0,
  discount: 0,
}, {
  type,
  payload
}) => {
  switch (type) {
    case UPDATE_SHIRT_PRICE:
    case UPDATE_SHIRT_PRICE_BY_BUTTONS:
    case UPDATE_SHIRT_PRICE_BY_FABRIC:
      return payload;
    case UPDATE_SHIRT_PRICE_BY_ATTR:
      return {
        price: state.price + payload.price,
        discount: state.discount + payload.discount,
      }
    default:
      return state
  }
}

const contrastsPrice = (state = {
  price: 0,
  discount: 0,
}, {
  type,
  payload
}) => {
  switch (type) {
    case UPDATE_SHIRT_PRICE_BY_CONTRAST:
      return {
        price: state.price + payload.price,
        discount: state.discount + payload.discount,
      }
    default:
      return state
  }
}


export default combineReducers({
  shirtPrice,
})
